// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   Globe,
//   Code2,
//   FileText,
//   Layers,
//   Monitor,
//   Database,
//   UserCheck,
//   Rocket,
//   BookOpen,
// } from "lucide-react";

// const DotNet = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1200, once: true, easing: "ease-in-out" });
//   }, []);

//   const dotNetTopics = [
//     {
//       title: "ASP.NET",
//       description:
//         "Framework for building secure and scalable web applications with MVC, Razor Pages, and Web API.",
//       icon: <Globe className="text-white animate-bounce" size={40} />,
//       animation: "fade-right",
//       color: "from-blue-500 to-blue-700",
//     },
//     {
//       title: "C#.NET",
//       description:
//         "Powerful OOP language for building desktop, web, mobile apps, and even games using .NET platform.",
//       icon: <Code2 className="text-white animate-pulse" size={40} />,
//       animation: "fade-left",
//       color: "from-indigo-500 to-indigo-700",
//     },
//     {
//       title: "VB.NET",
//       description:
//         "Beginner-friendly and versatile language for rapid desktop and business app development.",
//       icon: <FileText className="text-white animate-bounce" size={40} />,
//       animation: "zoom-in-up",
//       color: "from-purple-500 to-purple-700",
//     },
//     {
//       title: ".NET Framework",
//       description:
//         "Classic Windows development platform with CLR, libraries, and runtime environment support.",
//       icon: <Layers className="text-white animate-spin" size={40} />,
//       animation: "flip-up",
//       color: "from-green-500 to-green-700",
//     },
//     {
//       title: ".NET Core / .NET 5+",
//       description:
//         "Cross-platform, high-performance runtime for modern apps running on Windows, Linux, and macOS.",
//       icon: <Monitor className="text-white animate-shake" size={40} />,
//       animation: "flip-down",
//       color: "from-red-500 to-red-700",
//     },
//   ];

//   const whyChoose = [
//     {
//       title: "Expert Mentorship",
//       description:
//         "Learn directly from experienced .NET developers working in real-world projects.",
//       icon: <UserCheck className="text-white animate-bounce" size={36} />,
//       animation: "fade-up-right",
//       color: "from-blue-400 to-blue-600",
//     },
//     {
//       title: "Real Projects",
//       description:
//         "Work on live projects that simulate actual industry challenges and requirements.",
//       icon: <Database className="text-white animate-pulse" size={36} />,
//       animation: "fade-up-left",
//       color: "from-green-400 to-green-600",
//     },
//     {
//       title: "Career Growth",
//       description:
//         "Placement assistance, resume reviews, and mock interviews to kickstart your career.",
//       icon: <Rocket className="text-white animate-shake" size={36} />,
//       animation: "zoom-out-up",
//       color: "from-red-400 to-red-600",
//     },
//     {
//       title: "Future Tech",
//       description:
//         "Learn React, Tailwind, and integrate with .NET for full-stack mastery.",
//       icon: <BookOpen className="text-white animate-spin" size={36} />,
//       animation: "zoom-out-down",
//       color: "from-purple-400 to-purple-600",
//     },
//   ];

//   const skills = [
//     {
//       skill: "ASP.NET",
//       desc: "Build robust, secure, and scalable web apps using MVC and Web API.",
//       icon: "🌐",
//       color: "from-blue-500 to-blue-700",
//     },
//     {
//       skill: "C#.NET",
//       desc: "Master object-oriented programming with C# for apps, games, and backend services.",
//       icon: "💻",
//       color: "from-indigo-500 to-indigo-700",
//     },
//     {
//       skill: "VB.NET",
//       desc: "Use VB.NET for beginner-friendly desktop and enterprise applications.",
//       icon: "📘",
//       color: "from-purple-500 to-purple-700",
//     },
//     {
//       skill: "Entity Framework",
//       desc: "Work with databases effortlessly using Microsoft's ORM tool.",
//       icon: "🗄️",
//       color: "from-green-500 to-green-700",
//     },
//     {
//       skill: "React JS",
//       desc: "Build modern, interactive UIs and integrate them with .NET backend.",
//       icon: "⚛️",
//       color: "from-pink-500 to-pink-700",
//     },
//   ];

//   return (
//     <div className="font-sans">
//       {/* Hero Section */}
//       <section
//         className="relative bg-cover bg-center text-white py-24 text-center overflow-hidden"
//         style={{
//           backgroundImage:
//             "url('https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
//         }}
//       >
//         <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-indigo-900/70"></div>

//         <div className="relative z-10">
//           <h1
//             className="text-5xl md:text-6xl font-extrabold mb-6 drop-shadow-lg"
//             data-aos="zoom-in"
//           >
//             Master .NET & Modern Development
//           </h1>
//           <p
//             className="text-lg md:text-2xl opacity-90 max-w-3xl mx-auto mb-8"
//             data-aos="fade-up"
//           >
//             From ASP.NET to Full-Stack with React & Tailwind
//           </p>
//           <a
//             href="/contact"
//             data-aos="flip-left"
//             className="bg-white text-blue-700 px-10 py-4 font-semibold rounded-xl shadow-xl hover:bg-gray-100 transition-transform hover:scale-110 inline-block"
//           >
//             Enroll Now
//           </a>
//         </div>
//       </section>

//       {/* About .NET Section */}
//       <section className="container mx-auto px-6 py-20">
//         <h2
//           className="text-4xl font-bold text-center mb-10 text-black"
//           data-aos="fade-down"
//         >
//           Why .NET?
//         </h2>
//         <p
//           className="text-gray-600 text-center max-w-4xl mx-auto mb-14 leading-relaxed"
//           data-aos="fade-up"
//         >
//           .NET empowers developers to build applications across platforms — from
//           web and desktop to mobile and cloud. Our program ensures you master
//           not only .NET technologies but also modern front-end tools.
//         </p>

//         <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
//           {dotNetTopics.map((topic, i) => (
//             <div
//               key={i}
//               data-aos={topic.animation}
//               className={`bg-gradient-to-br ${topic.color} shadow-xl rounded-2xl p-8 border border-gray-100 hover:rotate-1 hover:scale-105 transition-transform duration-500 text-center flex flex-col items-center justify-center`}
//             >
//               <div className="mb-4">{topic.icon}</div>
//               <h3 className="text-2xl font-semibold mb-4 text-white">
//                 {topic.title}
//               </h3>
//               <p className="text-white/90 leading-relaxed">{topic.description}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="bg-gradient-to-br from-gray-100 to-gray-200 py-20">
//         <div className="container mx-auto px-6">
//           <h2
//             className="text-4xl font-bold text-center mb-14 text-black"
//             data-aos="zoom-in"
//           >
//             Why Choose Us?
//           </h2>
//           <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
//             {whyChoose.map((item, i) => (
//               <div
//                 key={i}
//                 data-aos={item.animation}
//                 className={`bg-gradient-to-br ${item.color} shadow-lg rounded-xl p-8 text-center transform hover:rotate-2 hover:scale-105 transition-transform duration-500 flex flex-col items-center justify-center`}
//               >
//                 <div className="mb-4">{item.icon}</div>
//                 <h3 className="text-xl font-semibold mb-4 text-white">{item.title}</h3>
//                 <p className="text-white/90">{item.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Skills Section */}
//       <section className="py-20 container mx-auto px-6 text-center">
//         <h2
//           className="text-4xl font-bold mb-10 text-black"
//           data-aos="fade-down"
//         >
//           Skills You’ll Gain
//         </h2>
//         <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
//           {skills.map((item, i) => (
//             <div
//               key={i}
//               data-aos={i % 2 === 0 ? "fade-up" : "fade-down"}
//               className={`bg-gradient-to-br ${item.color} text-white shadow-lg rounded-xl p-6 hover:scale-105 transition-transform duration-500 flex flex-col items-center text-center`}
//             >
//               <div className="text-4xl mb-4 animate-bounce">{item.icon}</div>
//               <h3 className="text-xl font-semibold mb-2">{item.skill}</h3>
//               <p className="text-sm opacity-90">{item.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section
//         className="relative bg-cover bg-center text-white py-24 text-center overflow-hidden"
//         style={{
//           backgroundImage:
//             "url(https://st2.depositphotos.com/4021139/7396/i/450/depositphotos_73962183-stock-photo-dot-net-concept.jpg)",
//         }}
//       >
//         <div className="absolute inset-0 bg-black/60"></div>

//         <div className="relative z-10">
//           <h2
//             className="text-4xl md:text-5xl font-bold mb-6"
//             data-aos="fade-down"
//           >
//             Enroll & Transform Your Career
//           </h2>
//           <p
//             className="mb-10 max-w-3xl mx-auto opacity-90"
//             data-aos="fade-up"
//           >
//             Become an expert in .NET and full-stack development with hands-on
//             training and mentorship.
//           </p>
//           <a
//             href="/contact"
//             data-aos="zoom-in-up"
//             className="bg-white text-blue-700 px-10 py-4 font-semibold rounded-xl shadow-xl hover:bg-gray-100 transition-transform hover:scale-110 inline-block"
//           >
//             Join Now
//           </a>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default DotNet;

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Globe,
  Code2,
  FileText,
  Layers,
  Monitor,
  Database,
  UserCheck,
  Rocket,
  BookOpen,
  Briefcase,
  Cloud,
  Shield,
} from "lucide-react";

const DotNet = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true, easing: "ease-in-out" });
  }, []);

  const dotNetTopics = [
    {
      title: "ASP.NET",
      description:
        "Framework for building secure and scalable web applications with MVC, Razor Pages, and Web API.",
      icon: <Globe className="text-white animate-bounce" size={40} />,
      animation: "fade-right",
      color: "from-blue-500 to-blue-700",
    },
    {
      title: "C#.NET",
      description:
        "Powerful OOP language for building desktop, web, mobile apps, and even games using .NET platform.",
      icon: <Code2 className="text-white animate-pulse" size={40} />,
      animation: "fade-left",
      color: "from-indigo-500 to-indigo-700",
    },
    {
      title: "VB.NET",
      description:
        "Beginner-friendly and versatile language for rapid desktop and business app development.",
      icon: <FileText className="text-white animate-bounce" size={40} />,
      animation: "zoom-in-up",
      color: "from-purple-500 to-purple-700",
    },
    {
      title: ".NET Framework",
      description:
        "Classic Windows development platform with CLR, libraries, and runtime environment support.",
      icon: <Layers className="text-white animate-spin" size={40} />,
      animation: "flip-up",
      color: "from-green-500 to-green-700",
    },
    {
      title: ".NET Core / .NET 5+",
      description:
        "Cross-platform, high-performance runtime for modern apps running on Windows, Linux, and macOS.",
      icon: <Monitor className="text-white animate-shake" size={40} />,
      animation: "flip-down",
      color: "from-red-500 to-red-700",
    },
  ];

  const whyChoose = [
    {
      title: "Expert Mentorship",
      description:
        "Learn directly from experienced .NET developers working in real-world projects.",
      icon: <UserCheck className="text-white animate-bounce" size={36} />,
      animation: "fade-up-right",
      color: "from-blue-400 to-blue-600",
    },
    {
      title: "Real Projects",
      description:
        "Work on live projects that simulate actual industry challenges and requirements.",
      icon: <Database className="text-white animate-pulse" size={36} />,
      animation: "fade-up-left",
      color: "from-green-400 to-green-600",
    },
    {
      title: "Career Growth",
      description:
        "Placement assistance, resume reviews, and mock interviews to kickstart your career.",
      icon: <Rocket className="text-white animate-shake" size={36} />,
      animation: "zoom-out-up",
      color: "from-red-400 to-red-600",
    },
    {
      title: "Future Tech",
      description:
        "Learn React, Tailwind, and integrate with .NET for full-stack mastery.",
      icon: <BookOpen className="text-white animate-spin" size={36} />,
      animation: "zoom-out-down",
      color: "from-purple-400 to-purple-600",
    },
  ];

  const skills = [
    {
      skill: "ASP.NET",
      desc: "Build robust, secure, and scalable web apps using MVC and Web API.",
      icon: "🌐",
      color: "from-blue-500 to-blue-700",
    },
    {
      skill: "C#.NET",
      desc: "Master object-oriented programming with C# for apps, games, and backend services.",
      icon: "💻",
      color: "from-indigo-500 to-indigo-700",
    },
    {
      skill: "VB.NET",
      desc: "Use VB.NET for beginner-friendly desktop and enterprise applications.",
      icon: "📘",
      color: "from-purple-500 to-purple-700",
    },
    {
      skill: "Entity Framework",
      desc: "Work with databases effortlessly using Microsoft's ORM tool.",
      icon: "🗄️",
      color: "from-green-500 to-green-700",
    },
    {
      skill: "React JS",
      desc: "Build modern, interactive UIs and integrate them with .NET backend.",
      icon: "⚛️",
      color: "from-pink-500 to-pink-700",
    },
  ];

  const deepDive = [
    {
      title: "Enterprise-Ready",
      desc: "Used by Fortune 500 companies, .NET powers enterprise-scale solutions with reliability.",
      icon: <Briefcase className="text-blue-600" size={40} />,
      aos: "fade-left",
    },
    {
      title: "Cloud Integration",
      desc: "Seamlessly integrates with Microsoft Azure for cloud-native development.",
      icon: <Cloud className="text-purple-600" size={40} />,
      aos: "fade-right",
    },
    {
      title: "Security First",
      desc: "Inbuilt authentication, authorization, and encryption ensure application security.",
      icon: <Shield className="text-green-600" size={40} />,
      aos: "fade-left",
    },
  ];

  return (
    <div className="font-sans overflow-hidden">
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center text-white py-24 text-center overflow-hidden"
        style={{
          backgroundImage:
            "url('../assets/photo-1518770660439-4636190af475.AVIF')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-indigo-900/70"></div>

        <div className="relative z-10">
          <h1
            className="text-5xl md:text-6xl font-extrabold mb-6 drop-shadow-lg"
            data-aos="zoom-in"
          >
            Master .NET & Modern Development
          </h1>
          <p
            className="text-lg md:text-2xl opacity-90 max-w-3xl mx-auto mb-8"
            data-aos="fade-up"
          >
            From ASP.NET to Full-Stack with React & Tailwind
          </p>
          <a
            href="/contact"
            data-aos="flip-left"
            className="bg-white text-blue-700 px-10 py-4 font-semibold rounded-xl shadow-xl hover:bg-gray-100 transition-transform hover:scale-110 inline-block"
          >
            Enroll Now
          </a>
        </div>
      </section>

      {/* About .NET Section */}
      <section className="container mx-auto px-6 py-20">
        <h2
          className="text-4xl font-bold text-center mb-10 text-black"
          data-aos="fade-down"
        >
          Why .NET?
        </h2>
        <p
          className="text-gray-600 text-center max-w-4xl mx-auto mb-14 leading-relaxed"
          data-aos="fade-up"
        >
          .NET empowers developers to build applications across platforms — from
          web and desktop to mobile and cloud. Our program ensures you master
          not only .NET technologies but also modern front-end tools.
        </p>

        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {dotNetTopics.map((topic, i) => (
            <div
              key={i}
              data-aos={topic.animation}
              className={`bg-gradient-to-br ${topic.color} shadow-xl rounded-2xl p-8 border border-gray-100 hover:rotate-1 hover:scale-105 transition-transform duration-500 text-center flex flex-col items-center justify-center`}
            >
              <div className="mb-4">{topic.icon}</div>
              <h3 className="text-2xl font-semibold mb-4 text-white">
                {topic.title}
              </h3>
              <p className="text-white/90 leading-relaxed">
                {topic.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Deep Dive Section */}
      <section className="bg-gray-50 py-20 px-6">
        <h2
          className="text-4xl font-bold text-center mb-12 text-black"
          data-aos="fade-up"
        >
          Deep Dive into .NET
        </h2>
        <div className="max-w-5xl mx-auto space-y-12">
          {deepDive.map((item, i) => (
            <div
              key={i}
              data-aos={item.aos}
              className="bg-white shadow-lg rounded-xl p-8 flex items-center gap-6 hover:scale-105 transition-transform duration-500"
            >
              <div>{item.icon}</div>
              <div>
                <h3 className="text-2xl font-semibold text-gray-800 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="bg-gradient-to-br from-gray-100 to-gray-200 py-20">
        <div className="container mx-auto px-6">
          <h2
            className="text-4xl font-bold text-center mb-14 text-black"
            data-aos="zoom-in"
          >
            Why Choose Us?
          </h2>
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
            {whyChoose.map((item, i) => (
              <div
                key={i}
                data-aos={item.animation}
                className={`bg-gradient-to-br ${item.color} shadow-lg rounded-xl p-8 text-center transform hover:rotate-2 hover:scale-105 transition-transform duration-500 flex flex-col items-center justify-center`}
              >
                <div className="mb-4">{item.icon}</div>
                <h3 className="text-xl font-semibold mb-4 text-white">
                  {item.title}
                </h3>
                <p className="text-white/90">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section className="py-20 container mx-auto px-6 text-center">
        <h2
          className="text-4xl font-bold mb-10 text-black"
          data-aos="fade-down"
        >
          Skills You’ll Gain
        </h2>
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {skills.map((item, i) => (
            <div
              key={i}
              data-aos={i % 2 === 0 ? "fade-up" : "fade-down"}
              className={`bg-gradient-to-br ${item.color} text-white shadow-lg rounded-xl p-6 hover:scale-105 transition-transform duration-500 flex flex-col items-center text-center`}
            >
              <div className="text-4xl mb-4 animate-bounce">{item.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{item.skill}</h3>
              <p className="text-sm opacity-90">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section
        className="relative bg-cover bg-center text-white py-24 text-center overflow-hidden"
        style={{
          backgroundImage:
            "url(../assets/depositphotos_73962183-stock-photo-dot-net-concept.jpg)",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10">
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            data-aos="fade-down"
          >
            Enroll & Transform Your Career
          </h2>
          <p className="mb-10 max-w-3xl mx-auto opacity-90" data-aos="fade-up">
            Become an expert in .NET and full-stack development with hands-on
            training and mentorship.
          </p>
          <a
            href="/contact"
            data-aos="zoom-in-up"
            className="bg-white text-blue-700 px-10 py-4 font-semibold rounded-xl shadow-xl hover:bg-gray-100 transition-transform hover:scale-110 inline-block"
          >
            Join Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default DotNet;
